"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SynView = exports.SynViewButton = exports.SplitterConfig = exports.PaneConfig = exports.ViewSaveResult = void 0;
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const CommandLayout_1 = require("../../TdWebtoolkitControls/controls/Menu/CommandLayout");
const ContextMenu_1 = require("../../TdWebtoolkitControls/controls/Menu/ContextMenu");
require("../../TdWebtoolkitControls/controls/Menu/Menu");
const SelectionContext_1 = require("../../TdWebtoolkitControls/controls/Menu/SelectionContext");
const LocalStorageManager_1 = require("../../TdWebtoolkitControls/javascript/LocalStorageManager");
const Utilities_1 = require("../../TdWebtoolkitControls/javascript/Utilities");
const $ = require("jquery");
const TreeModel = require("tree-model");
const viewsjs = {};
const viewshtml = {};
var ViewSaveResult;
(function (ViewSaveResult) {
    ViewSaveResult[ViewSaveResult["Save"] = 1] = "Save";
    ViewSaveResult[ViewSaveResult["SaveAndClose"] = 2] = "SaveAndClose";
    ViewSaveResult[ViewSaveResult["Cancel"] = 3] = "Cancel";
})(ViewSaveResult = exports.ViewSaveResult || (exports.ViewSaveResult = {}));
//#endregion CALLBACK SIGNATURES
/**
* Lifecycle status of a view
*/
var ViewStatus;
(function (ViewStatus) {
    /**
    * View is unready: Neither View's template has been rendered nor have controls been created
    */
    ViewStatus[ViewStatus["Unready"] = 0] = "Unready";
    /**
    * View's template has been rendered
    */
    ViewStatus[ViewStatus["Rendered"] = 1] = "Rendered";
    /**
    * View's template has been rendered and controls have been created
    */
    ViewStatus[ViewStatus["Created"] = 2] = "Created";
})(ViewStatus || (ViewStatus = {}));
/**
* Configuration for a single pane
*/
class PaneConfig {
    constructor() {
        this.m_collapsed = false;
    }
}
exports.PaneConfig = PaneConfig;
/**
* Pane configuration for a single splitter
*/
class SplitterConfig {
    constructor(paneConfigs) {
        this.m_paneConfigs = paneConfigs;
    }
}
exports.SplitterConfig = SplitterConfig;
/**
* Class encapsulating view-specific buttons
*/
class SynViewButton {
    //#endregion MEMBER VARIABLES
    //#region CONSTRUCTOR
    constructor(id, title, icon, clickHandler, toggleable = false, initiallyActivated = true) {
        /**
        * FontAwesome icon class w/o the fa pseucoclass (e.g. "fa-sitemap")
        */
        this.m_icon = "";
        this.m_id = id;
        this.m_title = title;
        this.m_icon = icon;
        this.m_clickHandler = clickHandler;
        this.m_toggleable = toggleable;
        this.m_initiallyActivated = initiallyActivated;
    }
}
exports.SynViewButton = SynViewButton;
/**
* Base class for all Views. Note that all methods that can be inherited are public since TS1.0 does not have the
* "protected" keyword.
*/
class SynView {
    //#endregion Events
    //#endregion MEMBER VARIABLES
    //#region CONSTRUCTOR
    constructor() {
        this.m_raiseBeforeExecuteMethod = false;
        this.m_hasMenu = true;
        this.m_hasContextMenu = true;
    }
    get MainMenu() {
        if (this.m_onViewGetMenu)
            return this.m_onViewGetMenu(this);
        return $();
    }
    set MainMenu(menu) {
        if (this.m_onViewSetMenu)
            this.m_onViewSetMenu(this, menu);
    }
    get IsActiveView() {
        if (this.m_onViewGetIsActive)
            return this.m_onViewGetIsActive(this);
        return false;
    }
    /**
    * =true: View hat ein ContextMenu (=default). ContextMenu wird bei synList und synTree angezeigt.
    */
    get HasContextMenu() {
        return this.m_hasContextMenu;
    }
    set HasContextMenu(value) {
        if ((value !== this.m_hasContextMenu)) {
            this.m_hasContextMenu = value;
            if (value)
                this.activateObjectContextMenu();
            else
                this.deactivateObjectContextMenu();
        }
    }
    /**
    * Wrapper für ContextMenu
    */
    get ContextMenu() {
        const that = this;
        if ((!that.m_contextMenu) && (that.m_hasContextMenu))
            that.m_contextMenu = new ContextMenu_1.ContextMenu();
        return that.m_contextMenu;
    }
    /**
    * Enthält das Layout für Mainmenu und ContextMenu
    */
    get CommandLayouts() {
        const that = this;
        if (!that.m_commandLayouts)
            that.m_commandLayouts = new CommandLayout_1.CommandLayoutsType({ viewId: that.m_viewName, raiseBeforeExecuteMethod: that.raiseBeforeExecuteMethod });
        return that.m_commandLayouts;
    }
    /**
    * Command-spezifischen Trigger (beforeExecuteMethod, afterExecuteMethod, forceRefresh) werden bei diesem Objekt aufgerufen
    */
    get CommandTriggerTarget() {
        return this.m_$container;
    }
    //#endregion CONSTRUCTOR
    //#region MEMBER PROPERTIES
    get viewName() {
        return this.m_viewName;
    }
    get viewIndex() {
        return this.m_viewIndex;
    }
    // Getter for kendo view
    get view() {
        return this.m_view;
    }
    get title() {
        return this.m_title;
    }
    get icon() {
        return this.m_icon ? "fa " + this.m_icon : "";
    }
    set icon(val) {
        this.m_icon = val;
    }
    get editableFavorites() {
        return this.m_editableFavorites;
    }
    set editableFavorites(val) {
        this.m_editableFavorites = val;
    }
    set refreshNecessary(val) {
        this.m_refreshNecessary = val;
    }
    set onViewLoaded(val) {
        this.m_onViewLoaded = val;
    }
    set onViewMadeChanges(val) {
        this.m_onViewMadeChanges = val;
    }
    set onViewButtonsReady(val) {
        this.m_onViewButtonsReady = val;
    }
    set onViewActivated(val) {
        this.m_onViewActivated = val;
    }
    set onViewDeactivated(val) {
        this.m_onViewDeactivated = val;
    }
    set onViewResize(val) {
        this.m_onViewResize = val;
    }
    set onViewHistory(val) {
        this.m_onViewHistory = val;
    }
    set onViewMenuResize(val) {
        this.m_onViewMenuResize = val;
    }
    set onRefresh(val) {
        this.m_onRefresh = val;
    }
    set onViewGetMenu(val) {
        this.m_onViewGetMenu = val;
    }
    set onViewSetMenu(val) {
        this.m_onViewSetMenu = val;
    }
    set onViewGetIsActive(val) {
        this.m_onViewGetIsActive = val;
    }
    set raiseBeforeExecuteMethod(val) {
        this.m_raiseBeforeExecuteMethod = val;
    }
    get raiseBeforeExecuteMethod() {
        return this.m_raiseBeforeExecuteMethod;
    }
    //#endregion MEMBER PROPERTIES
    //#region MEMBER METHODS
    //#region Main
    /**
    * Factory method for view creation. Callback is invoked upon completion of view.
    * @param viewName Internal name (id) of the view.
    * @param viewIndex zero-based index of the view, by which it will be sorted
    * @param cb Callback called upon completion of view. The "view" parameter of the callback might be undefined, in which case files required for the view are missing.
    */
    static getView(viewName, viewIndex, cb) {
        const viewTest = new viewsjs[viewName][viewName]();
        viewTest.init(viewName, viewIndex, viewshtml[viewName]);
        cb(viewTest);
    }
    /**
    * Initialize the view
    * @param viewName Internal name (id) of the view.
    * @param viewIndex zero-based intex of the view, by which it will be sorted
    * @param viewHtml HTML template for rendering the view
    */
    init(viewName, viewIndex, viewHtml) {
        this.m_clientDeviceClass = Utilities_1.synUtil.clientDeviceClass;
        this.m_saveInProgress = false;
        this.m_refreshNecessary = false;
        this.m_UIDisabled = false;
        this.m_viewName = viewName;
        this.m_viewIndex = viewIndex;
        this.m_title = Utilities_1.synUtil.Strings.getValue("webviewname." + this.m_viewName);
        this.m_viewHtml = viewHtml;
        this.m_viewButtons = [];
        this.m_icon = "";
        this.m_viewStatus = ViewStatus.Unready;
        this.m_splittersInitialized = false;
    }
    /**
    * Activate the view
    */
    activate() {
        const that = this;
        that.load();
        that.setURL();
        document.title = Utilities_1.synUtil.Strings.getValue("titleappl") + (that.title ? " / " + that.title : "");
        if (that.m_onViewActivated)
            that.m_onViewActivated(that);
        that.logView();
        $("body").off("menuLogFullLicense").on("menuLogFullLicense", ".synMenu, .synContextMenu", () => {
            that.logFullLicense();
        });
        $("body").off("controlLogFullLicense").on("controlLogFullLicense", () => {
            that.logFullLicense();
        });
    }
    /**
    * Deactivate the view
    */
    deactivate() {
        const that = this;
        that.disableUI(false);
        if (that.m_onViewDeactivated)
            that.m_onViewDeactivated(that);
        $("body").off("menuLogFullLicense");
        $("body").off("controlLogFullLicense");
    }
    /** This method is called when the window/tab containing the view gets focus
    *
    */
    onWindowFocus() { }
    /** This method is called when the window/tab containing the view loses focus
    *
    */
    onWindowBlur() { }
    /**
    * Ask the user if they want to save changes and communicate the result to the view
    */
    askSaveChanges(allowSaveAndClose, cb) {
        const that = this;
        that.disableUI();
        const allow = allowSaveAndClose && "phone" !== that.m_clientDeviceClass;
        $(".changeBar .btn.save").off("click").on("click", function () {
            cb(ViewSaveResult.Save);
        });
        $(".changeBar .btn.saveAndClose").toggle(allow).off("click").on("click", function () {
            cb(ViewSaveResult.SaveAndClose);
        });
        $(".changeBar .btn.cancel").off("click").on("click", function () {
            if (Utilities_1.synUtil.Configs.getValue("webconfirmcancel") !== "N") {
                if (window.confirm(Utilities_1.synUtil.Strings.getValue("confirmcancel")))
                    cb(ViewSaveResult.Cancel);
            }
            else
                cb(ViewSaveResult.Cancel);
        });
        // Handle save shortcut
        const cmdSave = function (e) {
            if (!$(".changeBar").hasClass("k-state-collapsed")) {
                cb(ViewSaveResult.Save);
                e.stopPropagation();
            }
        };
        that.m_$container.off("cmdSave").on("cmdSave", cmdSave);
        that.m_$container.off("viewcmdSave").on("viewcmdSave", cmdSave);
    }
    /**
    * Disables some parts of the UI to prevent from navigating away before saving changes. Derived views might override
    * this method and disable additional UI controls, but they have to call this base implementation.
    *
    * @param disable If true, disable the UI. Else (re-)enable the UI.
    */
    disableUI(disable = true) {
        const spl = $(".appContainer").data("kendoSplitter");
        const sideNavItems = $(".appContainer").find(".sideNav").find(".views .synView, .history .item");
        if (disable) {
            spl.collapse($(".menuPane"));
            spl.expand($(".changeBar"));
            // $(".changeBar").css("border-bottom", "2px solid #245c86");
            sideNavItems.addClass("disabled");
            sideNavItems.find(".text a").attr("onclick", "return false;"); // For IE11
            this.m_UIDisabled = true;
        }
        else {
            $(".changeBar .btn").off("click");
            spl.collapse($(".changeBar"));
            spl.expand($(".menuPane"));
            $(".changeBar").css("border-bottom", "0px solid orange");
            $(".menuPane").css("overflow", "visible");
            sideNavItems.removeClass("disabled");
            sideNavItems.find(".text a").removeAttr("onclick"); // For IE11
            this.m_UIDisabled = false;
        }
    }
    // Recursively add pane nodes
    findAndAddNode(tree, rootNode, DOMNode) {
        const that = this;
        // One pane must always be without a set size and non toggleable!
        let hasMandatoryPane = false;
        DOMNode.children("div").each(function (idx, div) {
            const $div = $(div);
            if ($div.hasClass("synPane")) {
                if ((!$(div).attr("data-toggleable") || $(div).attr("data-toggleable") === "false") && !$(div).attr("data-panesize"))
                    hasMandatoryPane = true;
                const newNode = rootNode.addChild(tree.parse({
                    paneSize: $div.attr("data-panesize"),
                    paneOrientation: $div.attr("data-paneorientation"),
                    paneGuid: Utilities_1.synUtil.getGUID(),
                    parentGuid: DOMNode.attr("data-paneguid"),
                }));
                $div.attr("data-paneguid", newNode.model.paneGuid).attr("data-parentguid", newNode.model.parentGuid);
                that.findAndAddNode(tree, newNode, $div);
            }
        });
        if (!hasMandatoryPane && rootNode.children.length > 0)
            alert("Critical! tmpl.htm setup wrong! One synPane per splitter must always be without data-panesize and non-toggleable!");
    }
    // Create pane node tree from DOM
    createTreeFromDOM(rootDOMNode) {
        const that = this;
        let tree;
        let treeRoot;
        let hasPanes = false;
        rootDOMNode.children("div").each(function (idx, div) {
            if ($(div).hasClass("synPane"))
                hasPanes = true;
        });
        if (hasPanes) {
            tree = new TreeModel();
            const rootGUID = Utilities_1.synUtil.getGUID();
            treeRoot = tree.parse({
                paneGuid: rootGUID,
            });
            rootDOMNode.attr("data-paneguid", rootGUID);
            that.m_paneTreeRoot = treeRoot;
            that.findAndAddNode(tree, treeRoot, rootDOMNode);
        }
    }
    // Compare tree schematas (Only structure and orientation)
    compareTrees($this, rootA, rootB) {
        if (rootA.children.length !== rootB.children.length)
            return false;
        // Check if both nodes are valid
        if ((rootA.model && !rootB.model) || (!rootA.model && rootB.model))
            return false;
        // Only check pane if not root node
        if (rootA.model.parentGuid) {
            if ((rootA.model.paneOrientation && !rootB.model.paneOrientation) || (!rootA.model.paneOrientation && rootB.model.paneOrientation))
                return false;
            if (rootA.model.paneOrientation) {
                if (rootA.model.paneOrientation !== rootB.model.paneOrientation)
                    return false;
            }
        }
        for (let i = 0; i < rootA.children.length; i++) {
            if (!$this.compareTrees($this, rootA.children[i], rootB.children[i]))
                return false;
        }
        return true;
    }
    // Copy paneSize from one tree to other (must be the same tree structure!)
    copyTreePaneSize($this, treeOldSize, treeNewSize) {
        // Check if not root node
        if (treeOldSize.model.paneSize)
            treeOldSize.model.paneSize = treeNewSize.model.paneSize;
        for (let i = 0; i < treeOldSize.children.length; i++)
            $this.copyTreePaneSize($this, treeOldSize.children[i], treeNewSize.children[i]);
    }
    /**
    * Setup panes of view based on the view's HTML template
    */
    setupView() {
        const that = this;
        const localStorageKey = that.m_viewName;
        const createPanes = function (node) {
            const $node = $("div[data-paneguid='" + node.model.paneGuid + "']").css("box-sizing", "border-box");
            if (node.hasChildren()) {
                const panes = [];
                let orientation;
                node.children.forEach(function (childNode) {
                    const $childNode = $("div[data-paneguid='" + childNode.model.paneGuid + "']");
                    const pane = {
                        collapsible: "phone" === that.m_clientDeviceClass || "true" === $childNode.attr("data-toggleable"),
                        scrollable: "true" === $childNode.attr("data-scrollable"),
                    };
                    const paneSize = childNode.model.paneSize;
                    if (paneSize) {
                        if (paneSize.endsWith("%"))
                            pane.size = paneSize;
                        else
                            pane.size = (parseInt(paneSize, 10) * 100 / 12) + "%";
                    }
                    const paneOrientation = $childNode.attr("data-paneorientation");
                    if (paneOrientation) {
                        if (orientation && paneOrientation !== orientation)
                            alert("Critical! Two synPanes in the same splitter have different orientations!");
                        else
                            orientation = paneOrientation;
                    }
                    panes.push(pane);
                });
                if (!orientation)
                    orientation = "horizontal";
                $node.kendoSplitter({
                    orientation,
                    panes,
                    resize(e) {
                        if (that.m_splittersInitialized) {
                            const splitterNode = that.m_paneTreeRoot.first(function (node) {
                                return node.model.paneGuid === e.sender.element.attr("data-paneguid");
                            });
                            let totalPxSize;
                            if (e.sender.options.orientation === "vertical")
                                totalPxSize = e.sender.element.height();
                            else
                                totalPxSize = e.sender.element.width();
                            for (let i = 0; i < splitterNode.children.length; i++) {
                                const sizeString = e.sender.options.panes[i].size;
                                if (sizeString) {
                                    if (sizeString.endsWith("%"))
                                        splitterNode.children[i].model.paneSize = sizeString;
                                    else if (sizeString.endsWith("px")) {
                                        const pxInt = parseInt(sizeString);
                                        splitterNode.children[i].model.paneSize = (pxInt / totalPxSize * 100) + "%";
                                    }
                                }
                            }
                            // Duplicate tree, prune it, save with new sizes
                            const tmpTreeJSON = JSON.parse(JSON.stringify(that.m_paneTreeRoot.model));
                            const pruneTree = function (rootTreeNode) {
                                delete rootTreeNode["paneGuid"];
                                delete rootTreeNode["parentGuid"];
                                if (rootTreeNode.children) {
                                    rootTreeNode.children.forEach(function (childNode) {
                                        pruneTree(childNode);
                                    });
                                }
                            };
                            pruneTree(tmpTreeJSON);
                            LocalStorageManager_1.LocalStorageManager.setItem(LocalStorageManager_1.LocalStorageType.Splitter, localStorageKey, JSON.stringify(tmpTreeJSON));
                        }
                        // Fullscreen
                        if (that.m_fullscreen === true) {
                            $(".sideNav").css("display", "none");
                            $(".menuPane").css("display", "none");
                            $("#contentPane").css("left", "0").css({
                                "width": "100%",
                                "height": "100%",
                            });
                            $(".innerContainer").css({
                                "top": "0",
                                "height": "100%",
                            });
                            $("#contentPane").find(".k-widget").first().css("border", "none");
                        }
                        that.resizeControls();
                        that.raiseOnViewResize();
                    }
                });
                that.restoreSplitterState($node);
            }
        };
        that.createTreeFromDOM(that.m_$container);
        if (that.m_paneTreeRoot) {
            const localStorageTree = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.Splitter, localStorageKey);
            if (localStorageTree) {
                const treeModel = new TreeModel();
                that.m_savedPaneTreeRoot = treeModel.parse(JSON.parse(localStorageTree));
                if (that.compareTrees(that, that.m_paneTreeRoot, that.m_savedPaneTreeRoot))
                    that.copyTreePaneSize(that, that.m_paneTreeRoot, that.m_savedPaneTreeRoot);
                else
                    LocalStorageManager_1.LocalStorageManager.removeItem(LocalStorageManager_1.LocalStorageType.Splitter, localStorageKey);
            }
            that.m_paneTreeRoot.walk(function (node) {
                createPanes(node);
            });
            that.m_splittersInitialized = true;
        }
    }
    restoreSplitterState($splitter) {
        const cfg = this.getSplitterConfig($splitter);
        for (let i = 0; i < cfg.m_paneConfigs.length; ++i) {
            if (cfg.m_paneConfigs[i].m_collapsed) {
                const $pane = $($splitter.children(".k-pane")[i]);
                $splitter.data("kendoSplitter").collapse($pane);
            }
        }
    }
    /**
    * Create a view's contents
    *
    * @param $container jQuery container for the view
    */
    createContents($container) {
        const that = this;
        if (that.m_viewStatus !== ViewStatus.Created) {
            that.m_$container = $container.children().css("height", "100%");
            that.setupView();
            that.recreateMenu();
            that.renderContents();
            that.createViewButtons();
            that.m_viewStatus = ViewStatus.Created;
            that.activateObjectContextMenu();
        }
        else {
            that.updateSelectionContext();
            that.createViewButtons();
            if (that.m_refreshNecessary) {
                that.forceRefresh(undefined);
                that.m_refreshNecessary = false;
            }
        }
    }
    /**
    * Update the URL's parameters with the current member variables of the view
    */
    setURL() { }
    ;
    /**
    * Counterpart of setURL(): Get the URL's parameters and assign corresponding member variables of the view
    */
    getParametersFromUrl() {
        this.m_id = typeof ($.address.parameter("id")) === "undefined" ? undefined : decodeURIComponent($.address.parameter("id"));
        if (typeof ($.address.parameter("relid")) === "undefined")
            this.m_relId = undefined;
        else
            this.m_relId = parseInt(decodeURIComponent($.address.parameter("relid")), 10);
        this.m_typeId = typeof ($.address.parameter("typeid")) === "undefined" ? undefined : decodeURIComponent($.address.parameter("typeid"));
    }
    /**
    * Called whenever container size changes (e.g. when browser window is resized)
    */
    resizeControls() { }
    ;
    activateObjectContextMenu() {
        const that = this;
        if ((that.m_$container) && (that.m_hasContextMenu)) {
            that.m_$container.off("onObjectContextMenu").on("onObjectContextMenu", (event, eventObjectContextMenu) => {
                that.ContextMenu.openAsync(eventObjectContextMenu, that.CommandLayouts, that.CommandTriggerTarget);
            });
        }
    }
    deactivateObjectContextMenu() {
        if (this.m_$container)
            this.m_$container.off("onObjectContextMenu");
        if (this.m_contextMenu)
            this.m_contextMenu.destroy();
    }
    /**
    * Resize menu to take the available horizontal space, without overlapping with the button bar
    */
    resizeMenu() {
        const that = this;
        if (that.MainMenu && that.MainMenu.data("synMenu")) {
            if (that.m_clientDeviceClass === "phone") {
                // that.MainMenu
                //     .css("max-height", 30 + "px !important");
                // $(".viewButtons").height(60);
            }
            else {
                // Let Menu take the remaining horizontal width
                const topBar = $(".topBar");
                const diff = topBar.innerWidth()
                    - topBar.children(".topBarRight").outerWidth(true)
                    - $(".synerisLogo").outerWidth(true)
                    - 50;
                that.MainMenu
                    .css("width", Math.floor(diff) + "px")
                    .synMenu("closeMenu");
                const newHeight = that.MainMenu.height();
                if (newHeight > 0)
                    that.raiseOnViewMenuResize(newHeight);
            }
        }
        else
            that.raiseOnViewMenuResize(60);
    }
    getSelectionContext() {
        return {
            parentControl: false,
            normalParentContext: {
                parentRelId: SelectionContext_1.SpecialRelIds.Undefined
            },
            parentControlParentContext: {
                parentRelId: SelectionContext_1.SpecialRelIds.Undefined
            },
            selectedIds: []
        };
    }
    emptySelection() {
        this.CommandLayouts.SelectionContext.FullSelectionContext = {
            parentControl: false,
            normalParentContext: {
                parentRelId: SelectionContext_1.SpecialRelIds.Undefined
            },
            parentControlParentContext: {
                parentRelId: SelectionContext_1.SpecialRelIds.Undefined
            },
            selectedIds: []
        };
        this.setURL();
        this.MainMenu.synMenu("revalidate");
    }
    updateSelectionContext() {
        const fullContext = this.getSelectionContext();
        this.CommandLayouts.SelectionContext.FullSelectionContext = fullContext;
        this.setURL();
        this.MainMenu.synMenu("revalidate");
    }
    /**
    * Returns to the last location:
    * + The last history element if a history exists
    * + Or the base Url of the webclient
    */
    goBack() {
        if (window.history.length > 1)
            window.history.back();
        else
            this.goHome();
    }
    goHome() {
        window.location.replace(tdBasePath);
    }
    /**
    * Return an object representation for a new favorite for this view. Favorites can be things such as search favorites,
    * presets for document graph, etc
    */
    getDataForNewFavorites() {
        return undefined;
    }
    //#endregion Main
    //#region Event raising
    /**
    * Raise "view made changes" event, communicating that a view made some changes which might result in refreshes
    * for other views.
   */
    raiseOnViewMadeChanges() {
        if (this.m_onViewMadeChanges)
            this.m_onViewMadeChanges(this);
    }
    /**
    * Raise "view buttons ready" event, communicating a view's buttons to the application
    */
    raiseOnViewButtonsReady(buttons) {
        if (this.m_onViewButtonsReady)
            this.m_onViewButtonsReady(buttons);
    }
    /**
    * Raise "view resize" event, communicating a necessary recalculation of sizes of a view's controls
    */
    raiseOnViewResize() {
        if (this.m_onViewResize)
            this.m_onViewResize(this);
    }
    /**
    * Raise "view history" event
    */
    raiseOnViewHistory(instanceId, instanceName, highlight) {
        if (this.m_onViewHistory)
            this.m_onViewHistory(this, instanceId, instanceName, highlight);
    }
    /**
    * Raise "view menu resize" event
    */
    raiseOnViewMenuResize(newHeight) {
        if (this.m_onViewMenuResize)
            this.m_onViewMenuResize(this, newHeight);
    }
    /**
    * Raise "refresh" event
    */
    raiseOnRefresh(modificationInfo) {
        if (this.m_onRefresh)
            this.m_onRefresh(this, modificationInfo);
    }
    //#endregion Event raising
    //#region Helpers
    /**
    * Load the view
    */
    load() {
        const that = this;
        if (that.m_viewStatus === ViewStatus.Unready) {
            that.m_view = new kendo.View(kendo.template(this.m_viewHtml)({ synUtil: Utilities_1.synUtil }));
            that.m_viewStatus = ViewStatus.Rendered;
            that.getParametersFromUrl();
        }
    }
    addViewButton($div) {
        const that = this;
        const id = $div.attr("id");
        const toggleIcon = $div.attr("data-toggleicon") || that.m_icon;
        const isPhoneAndParentsCollapsed = "phone" === this.m_clientDeviceClass && $div.parents(".k-state-collapsed").length > 0;
        const initiallyActivated = !$div.hasClass("k-state-collapsed") && !isPhoneAndParentsCollapsed && "true" !== $div.attr("data-initiallyhidden");
        if (id && ($div.attr("data-toggleable") || ("phone" === this.m_clientDeviceClass) && $div.attr("data-toggleicon"))) {
            that.m_viewButtons.push(new SynViewButton(id, "", toggleIcon, (id, toggle) => {
                const $pane = $("#" + id);
                that.togglePane($pane, !toggle);
            }, true, initiallyActivated));
        }
    }
    /**
    * Create standard view buttons (e.g. buttons to toggle certain panes of a view)
    */
    createViewButtons() {
        const that = this;
        that.m_viewButtons = [];
        // View buttons for all layers (depth first)
        const selector = "phone" === that.m_clientDeviceClass ? "div.k-pane" : "div.k-pane[data-toggleable='true']";
        const nestedDivs = that.m_$container.find(selector);
        for (let i = 0; i < nestedDivs.length; i++)
            that.addViewButton($(nestedDivs[i]));
        that.raiseOnViewButtonsReady(that.m_viewButtons);
    }
    togglePane($pane, collapse) {
        const that = this;
        const $parent = $pane.parent();
        const $panes = $parent.children(".k-pane");
        const cfg = that.getSplitterConfig($parent);
        cfg.m_paneConfigs[$panes.index($pane)].m_collapsed = collapse;
        if (collapse)
            $pane.parent().data("kendoSplitter").collapse($pane);
        else {
            $pane.parent().data("kendoSplitter").expand($pane);
            if ("phone" === that.m_clientDeviceClass) {
                $panes.not($pane).each((idx, elem) => {
                    that.togglePane($(elem), true);
                });
                if ($parent.parent().data("kendoSplitter"))
                    that.togglePane($parent, false);
            }
        }
        that.setSplitterConfig($parent, cfg);
    }
    /**
    * Create main menu (destroy previous main menu if it exists)
    */
    recreateMenu() {
        this.destroyOldMenu();
        this.createNewMenu();
    }
    destroyOldMenu() {
        const oldMenu = this.MainMenu;
        if (oldMenu.length) {
            if (oldMenu.data("synMenu"))
                oldMenu.synMenu("destroy");
            oldMenu.remove();
        }
    }
    createNewMenu() {
        const that = this;
        if (!that.m_hasMenu)
            return;
        that.MainMenu = $("<ul />")
            .one("beginFetchMenuLayout", () => {
            that.resizeMenu();
        })
            .one("initSuccess", () => {
            that.resizeMenu();
        })
            .synMenu({
            viewId: that.m_viewName,
            raiseBeforeExecuteMethod: that.raiseBeforeExecuteMethod,
        }, that.CommandLayouts, that.CommandTriggerTarget);
        that.CommandTriggerTarget.off("forceRefresh").on("forceRefresh", (_e, info) => {
            that.raiseOnRefresh(info);
            that.forceRefresh(info);
        });
    }
    getSplitterConfig($splitter) {
        let config;
        if ("phone" !== this.m_clientDeviceClass) {
            const key = this.getSplitterConfigKey($splitter);
            const configStr = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.Splitter, key);
            if (configStr != undefined) {
                try {
                    config = JSON.parse(configStr);
                }
                catch (e) { }
            }
        }
        if (config == undefined) {
            const paneConfigs = [];
            const $panes = $splitter.children("div.k-pane");
            for (let i = 0; i < $panes.length; ++i) {
                const cfg = new PaneConfig();
                if ("phone" === this.m_clientDeviceClass)
                    cfg.m_collapsed = i !== 0;
                paneConfigs.push(cfg);
            }
            config = new SplitterConfig(paneConfigs);
        }
        return config;
    }
    setSplitterConfig($splitter, value) {
        if ("phone" !== this.m_clientDeviceClass) {
            const key = this.getSplitterConfigKey($splitter);
            if (value == undefined)
                LocalStorageManager_1.LocalStorageManager.removeItem(LocalStorageManager_1.LocalStorageType.Splitter, key);
            else
                LocalStorageManager_1.LocalStorageManager.setItem(LocalStorageManager_1.LocalStorageType.Splitter, key, JSON.stringify(value));
        }
    }
    getSplitterConfigKey($splitter) {
        let key = "splitterConfig_" + this.m_viewName;
        if (!$splitter.is(this.m_$container)) {
            const subKey = $splitter.attr("data-persistid") || $splitter.attr("id") || "nested";
            key += "_" + subKey;
        }
        return key;
    }
    logView() {
        const that = this;
        if (that.viewName.toLowerCase() === "_gui_test")
            return;
        const InitCSRFToken = window.sessionStorage.getItem(that.viewName + "_csrf");
        const InitDate = window.sessionStorage.getItem(that.viewName + "_date");
        const currentDate = new Date();
        if ((InitCSRFToken !== Utilities_1.synUtil.requestVerificationToken) || (currentDate.toDateString() !== InitDate)) {
            const ViewName = { viewname: that.viewName };
            Utilities_1.synUtil.getAJAXData({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("LogView"),
                requestData: JSON.stringify(ViewName),
                done() {
                    window.sessionStorage.setItem(that.viewName + "_csrf", Utilities_1.synUtil.requestVerificationToken);
                    window.sessionStorage.setItem(that.viewName + "_date", currentDate.toDateString());
                },
                fail(jqXHR, textStatus, errorThrown, url) {
                    Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                }
            });
        }
    }
    logFullLicense() {
        const that = this;
        if (that.viewName !== "acquisition" && that.viewName !== "visitormanagement") {
            const InitCSRFToken = window.sessionStorage.getItem("synfulllicense_csrf");
            const InitDate = window.sessionStorage.getItem("synfulllicense_date");
            const currentDate = new Date();
            if ((InitCSRFToken !== Utilities_1.synUtil.requestVerificationToken) || (currentDate.toDateString() !== InitDate)) {
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("LogFullLicense"),
                    done() {
                        window.sessionStorage.setItem("synfulllicense_csrf", Utilities_1.synUtil.requestVerificationToken);
                        window.sessionStorage.setItem("synfulllicense_date", currentDate.toDateString());
                    },
                    fail(jqXHR, textStatus, errorThrown, url) {
                        Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                    }
                });
            }
        }
    }
}
exports.SynView = SynView;
//#endregion Helpers
//#endregion MEMBER METHODS
// Requires for views must be after the declaration of the SynView class or SynView is an empty exported object (Circular dependency)
viewsjs["_gui_test"] = require("./_GUI_TEST/_GUI_TEST");
viewsjs["acquisition"] = require("./acquisition/acquisition");
viewsjs["confirmation"] = require("./confirmation/confirmation");
viewsjs["content"] = require("./content/content");
viewsjs["dashboard"] = require("./dashboard/dashboard");
viewsjs["facetteSearch"] = require("./facetteSearch/facetteSearch");
viewsjs["graph"] = require("./graph/graph");
viewsjs["lms"] = require("./lms/lms");
viewsjs["instructionProcessingMatrix"] = require("./instructionProcessingMatrix/instructionProcessingMatrix");
viewsjs["lmsAdmin"] = require("./lmsAdmin/lmsAdmin");
viewsjs["newDoc"] = require("./newDoc/newDoc");
viewsjs["newDocMulti"] = require("./newDocMulti/newDocMulti");
viewsjs["properties"] = require("./properties/properties");
viewsjs["search"] = require("./search/search");
viewsjs["activities"] = require("./activities/activities");
viewsjs["structure"] = require("./structure/structure");
viewsjs["structuredDocs"] = require("./structuredDocs/structuredDocs");
viewsjs["visitorManagement"] = require("./visitorManagement/visitorManagement");
viewsjs["processmap"] = require("./processmap/processmap");
viewsjs["roles"] = require("./roles/roles");
viewsjs["qualifications"] = require("./qualifications/qualifications");
viewshtml["_gui_test"] = require("./_GUI_TEST/_GUI_TEST.tmpl.htm");
viewshtml["acquisition"] = require("./acquisition/acquisition.tmpl.htm");
viewshtml["confirmation"] = require("./confirmation/confirmation.tmpl.htm");
viewshtml["content"] = require("./content/content.tmpl.htm");
viewshtml["dashboard"] = require("./dashboard/dashboard.tmpl.htm");
viewshtml["facetteSearch"] = require("./facetteSearch/facetteSearch.tmpl.htm");
viewshtml["graph"] = require("./graph/graph.tmpl.htm");
viewshtml["lms"] = require("./lms/lms.tmpl.htm");
viewshtml["instructionProcessingMatrix"] = require("./instructionProcessingMatrix/instructionProcessingMatrix.tmpl.htm");
viewshtml["lmsAdmin"] = require("./lmsAdmin/lmsAdmin.tmpl.htm");
viewshtml["newDoc"] = require("./newDoc/newDoc.tmpl.htm");
viewshtml["newDocMulti"] = require("./newDocMulti/newDocMulti.tmpl.htm");
viewshtml["properties"] = require("./properties/properties.tmpl.htm");
viewshtml["search"] = require("./search/search.tmpl.htm");
viewshtml["activities"] = require("./activities/activities.tmpl.htm");
viewshtml["structure"] = require("./structure/structure.tmpl.htm");
viewshtml["structuredDocs"] = require("./structuredDocs/structuredDocs.tmpl.htm");
viewshtml["visitorManagement"] = require("./visitorManagement/visitorManagement.tmpl.htm");
viewshtml["processmap"] = require("./processmap/processmap.tmpl.htm");
viewshtml["roles"] = require("./roles/roles.tmpl.htm");
viewshtml["qualifications"] = require("./qualifications/qualifications.tmpl.htm");
const customerViews = require("./CustomerViews");
for (const key in customerViews.customerViewsJS) {
    if (customerViews.customerViewsJS.hasOwnProperty(key))
        viewsjs[key] = customerViews.customerViewsJS[key];
}
for (const key in customerViews.customerViewsHTML) {
    if (customerViews.customerViewsHTML.hasOwnProperty(key))
        viewshtml[key] = customerViews.customerViewsHTML[key];
}
